<div class="exp-panel" [class.is-busy]="busy">
  <section class="exp-section">
    <h6 class="exp-head">{{ 'cv.tailor.inclusion.inCv' | translate }} &middot; {{ included.length }}</h6>
    <div cdkDropList [cdkDropListDisabled]="busy || disabled || !manualEdit" [cdkDropListLockAxis]="'y'" (cdkDropListDropped)="onDrop($event)">
      @for (e of included; track e.role_id) {
        <div class="exp-row" cdkDrag [cdkDragLockAxis]="'y'" [cdkDragDisabled]="busy || disabled || !manualEdit">
          @if (manualEdit) {
            <span class="exp-drag-handle" cdkDragHandle><nb-icon icon="menu-2-outline"></nb-icon></span>
          }
          <span class="exp-dot included"></span>
          <!-- One column for everything that belongs to the role, so the row's
               own flex lays out only [handle][dot][body][set-aside] and a long
               description wraps inside the body instead of becoming an inline
               flex sibling that overflows the row. -->
          <div class="exp-body">
            <div class="exp-main">
              <span class="exp-title">{{ e.title }}@if (e.employer) { <span class="exp-emp">&middot; {{ e.employer }}</span> }</span>
              <span class="exp-dates">{{ e.dates }}</span>
            </div>
            <!-- Gated like the handle and the Edit buttons beside it: the
                 description is a #1420 addition to this row (it is the text
                 the Edit button opens), and before #1420 the row showed only
                 exp-title and exp-dates. -->
            @if (manualEdit && e.description) {
              <div class="exp-desc">{{ e.description }}</div>
            }
            @if (manualEdit) {
              <div class="exp-edit-actions">
                <button nbButton ghost size="tiny" status="basic" type="button" [disabled]="busy || disabled"
                        (click)="editField.emit({ field: 'role', experienceId: e.role_id, label: e.employer, current: e.role })">
                  {{ 'cv.tailor.edit.editTitle' | translate }}
                </button>
                <button nbButton ghost size="tiny" status="basic" type="button" [disabled]="busy || disabled"
                        (click)="editField.emit({ field: 'description', experienceId: e.role_id, label: e.employer, current: e.description })">
                  {{ 'cv.tailor.edit.editDescription' | translate }}
                </button>
                <button nbButton ghost size="tiny" status="basic" type="button" [disabled]="busy || disabled"
                        (click)="editField.emit({ field: 'period', section: 'experience', id: e.role_id, label: e.title, start: e.start, end: e.end })">
                  {{ 'cv.tailor.edit.editDates' | translate }}
                </button>
              </div>
            }
          </div>
          <button nbButton ghost size="tiny" status="basic" type="button" [disabled]="busy || disabled" (click)="setAside.emit(e.role_id)">
            {{ 'cv.tailor.inclusion.setAside' | translate }}
          </button>
        </div>
      }
    </div>
  </section>

  @if (setAsideList.length > 0) {
    <section class="exp-section">
      <h6 class="exp-head">{{ 'cv.tailor.inclusion.setAsideHead' | translate }} &middot; {{ setAsideList.length }}</h6>
      @for (e of setAsideList; track e.role_id) {
        <div class="exp-row">
          <span class="exp-dot aside"></span>
          <div class="exp-main">
            <span class="exp-title">{{ e.title }}@if (e.employer) { <span class="exp-emp">&middot; {{ e.employer }}</span> }</span>
            <span class="exp-dates">{{ e.dates }}</span>
            @if (e.reason) { <span class="exp-reason">{{ e.reason }}</span> }
          </div>
          <button nbButton ghost size="tiny" status="primary" type="button" [disabled]="busy || disabled" (click)="restore.emit(e.role_id)">
            {{ 'cv.tailor.inclusion.restore' | translate }}
          </button>
        </div>
      }
    </section>
  }
</div>
